var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-8" },
            [
              _c("journey-dropdown", {
                model: {
                  value: _vm.journeyId,
                  callback: function($$v) {
                    _vm.journeyId = $$v
                  },
                  expression: "journeyId"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", { staticClass: "col-4" }, [
            _c(
              "a",
              {
                staticClass: "btn btn-outline-secondary",
                attrs: { href: _vm.journeyUrl }
              },
              [
                _c("i", { staticClass: "fas fa-route" }),
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.resource(
                        "JourneyBuilder_Overview_Composer_Button_Text"
                      )
                    ) +
                    "\n                "
                )
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-12" }, [
            _c("div", { staticClass: "d-inline-block mr-3" }, [
              _c("div", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.resource("Bool_Collapse")) +
                    "\n                    "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("alter-amount-button", {
                    attrs: {
                      total: -10,
                      disabled: !_vm.canDecreaseDisplayedTouchPoints
                    },
                    on: {
                      "alter-amount": _vm.incrementDisplayedTouchPointCount
                    }
                  }),
                  _vm._v(" "),
                  _c("alter-amount-button", {
                    attrs: {
                      total: -1,
                      disabled: !_vm.canDecreaseDisplayedTouchPoints
                    },
                    on: {
                      "alter-amount": _vm.incrementDisplayedTouchPointCount
                    }
                  })
                ],
                1
              )
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "d-inline-block" }, [
              _c("div", [
                _vm._v(
                  "\n                        " +
                    _vm._s(_vm.resource("Bool_Expand")) +
                    "\n                    "
                )
              ]),
              _vm._v(" "),
              _c(
                "div",
                [
                  _c("alter-amount-button", {
                    attrs: {
                      total: 1,
                      disabled: !_vm.canIncreaseDisplayedTouchPoints
                    },
                    on: {
                      "alter-amount": _vm.incrementDisplayedTouchPointCount
                    }
                  }),
                  _vm._v(" "),
                  _c("alter-amount-button", {
                    attrs: {
                      total: 10,
                      disabled: !_vm.canIncreaseDisplayedTouchPoints
                    },
                    on: {
                      "alter-amount": _vm.incrementDisplayedTouchPointCount
                    }
                  })
                ],
                1
              )
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "form-group" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-12" },
            [
              !_vm.isLoading
                ? _c("diagram", {
                    attrs: {
                      data: _vm.displayedTouchPoints,
                      types: _vm.sankeyTypes
                    },
                    on: { nodeClick: _vm.nodeClick }
                  })
                : _c("loading-box")
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _vm.brickId
        ? _c("modal", {
            ref: "brickInfoPopup",
            attrs: { size: "large" },
            on: {
              hidden: function($event) {
                _vm.brickId = null
              }
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "modal-body",
                  fn: function() {
                    return [
                      _c("touchpoint-statistics", {
                        attrs: { "brick-id": _vm.brickId, "is-sub-menu": false }
                      })
                    ]
                  },
                  proxy: true
                },
                {
                  key: "modal-footer",
                  fn: function() {
                    return [
                      _c("div", { staticClass: "row justify-content-end" }, [
                        _c("div", { staticClass: "col-auto" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-outline-secondary btn-lg",
                              attrs: { href: _vm.journeyUrl }
                            },
                            [
                              _c("i", { staticClass: "fas fa-route" }),
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.resource(
                                      "JourneyBuilder_Overview_Composer_Button_Text"
                                    )
                                  ) +
                                  "\n                    "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-secondary btn-lg",
                              on: {
                                click: function($event) {
                                  _vm.brickId = null
                                }
                              }
                            },
                            [
                              _c("i", { staticClass: "fas fa-check-circle" }),
                              _vm._v(
                                "  " +
                                  _vm._s(_vm.resource("Button_OK")) +
                                  "\n                    "
                              )
                            ]
                          )
                        ])
                      ])
                    ]
                  },
                  proxy: true
                }
              ],
              null,
              false,
              2758874657
            )
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }